import Fuse from 'fuse.js'

const fuseOptions = {
  keys: ['attributes.title', 'attributes.template_filename', 'attributes.tags'],
  threshold: 0.3,
  minMatchCharLength: 3
}

const filterTemplates = (templates, status, query) => {
  const inactiveTemplates = templates.filter(template => !template.attributes.active).sort((a, b) => {
    (a.attributes.title || '').localeCompare(b.attributes.title)
  })

  const activeTemplates = templates.filter(template => template.attributes.active).sort((a, b) => {
    new Date(b.attributes.activated_at) - new Date(a.attributes.activated_at)
  })

  const templatesByStatus = [...inactiveTemplates, ...activeTemplates].filter(template => {
    if (template.attributes.active) {
      if (status == 'all' || status == 'active') {
        return true
      } else {
        return false
      }
    } else {
      if (status == 'all' || status == 'inactive') {
        return true
      } else {
        return false
      }
    }
  })

  const filteredTemplates = () => {
    if (query.length >= 3) {
      const fuse = new Fuse(templatesByStatus, fuseOptions)
      return fuse.search(query).map(f => f.item)
    } else {
      return templatesByStatus
    }
  }

  return filteredTemplates()
}

export { filterTemplates }
